import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Appvillkor = lazy(() => import("@/pages/info/Appvillkor"));

export const Route = createFileRoute("/app-villkor")({
  head: () => seoHead("/app-villkor", { description: "Dessa villkor gäller när du laddar ner och använder Elmarknads mobilapp för iOS och Android. De kompletterar våra allmänna användarvillkor för Elmarknad.se." }),
  component: () => <Appvillkor />,
});
